import React from "react";

const FILTER_MARKER = "__hyperTableToolbarFilter" as const;

type MarkedFilterComponent = {
  [FILTER_MARKER]?: boolean;
};

function asMarkedFilterComponent(type: unknown): MarkedFilterComponent | null {
  if (typeof type !== "function" && typeof type !== "object") return null;
  return type as MarkedFilterComponent;
}

/** Tag filter components so Toolbar can split children without importing them (avoids circular deps). */
export function markHyperTableFilterComponent<T extends object>(component: T): T {
  (component as unknown as MarkedFilterComponent)[FILTER_MARKER] = true;
  return component;
}

export function isHyperTableFilterChild(child: React.ReactNode): boolean {
  if (!React.isValidElement(child)) return false;
  return asMarkedFilterComponent(child.type)?.[FILTER_MARKER] === true;
}
